import React from 'react';
import {Alert} from "antd";

const title= ({title, info}) => {

    return (
        <div className={'title-info'}>
            <h2 className={'title'}>{title}</h2>
            <Alert style={{maxHeight:200}} className={'mb-10 text-center info'} message={info} type="info"/>
        </div>

    );

}
export default title;